module.exports = __webpack_public_path__ + "img/baloons-at-dennis-party.dbeb7584.jpg";